var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6924 7.40343C12.3055 7.82085 11.6945 7.82085 11.3076 7.40343L10.6152 6.65647C9.80477 5.78217 8.70994 5.24834 7.5 5.24834C5.01472 5.24834 3 7.51322 3 10.3071C3 12.9856 4.28979 15.1973 6.15176 17.0145C8.01532 18.8333 10.2434 20.0395 11.5746 20.6551C11.853 20.7838 12.147 20.7838 12.4254 20.6551C13.7566 20.0395 15.9847 18.8333 17.8482 17.0145C19.7102 15.1973 21 12.9856 21 10.3071C21 7.51322 18.9853 5.24834 16.5 5.24834C15.2901 5.24834 14.1952 5.78217 13.3848 6.65647L12.6924 7.40343ZM12 5.03426C10.8321 3.77433 9.24649 3 7.5 3C3.91015 3 1 6.2715 1 10.3071C1 17.4661 7.97034 21.4195 10.8138 22.7344C11.5796 23.0885 12.4204 23.0885 13.1862 22.7344C16.0297 21.4195 23 17.4661 23 10.3071C23 6.2715 20.0899 3 16.5 3C14.7535 3 13.1679 3.77433 12 5.03426Z",
    fill: "CURRENTCOLOR"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAccount);
export default __webpack_public_path__ + "static/media/heart-account.ed4ffaa5.svg";
export { ForwardRef as ReactComponent };